import { store } from "../../../../..";
import { selectSelectedTeam } from "../../../../../features/clubhouse/clubhouseSlice";
import {
    globalActions,
    selectSetting,
} from "../../../../../features/global/globalSlice";
import { getTeam } from "../../../../../lib/api";

const playerLoader = async ({
    params,
    request,
}: {
    params: any;
    request: Request;
}) => {
    const { teamId } = params;
    const settings = store.getState().global.settings;
    const positions = store.getState().global.positions;
    const seasons = store.getState().global.seasons;
    const currentTeam = selectSelectedTeam(store.getState());

    const promises = [];

    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));
    !positions.length &&
        promises.push(store.dispatch(globalActions.getPositions()));
    !seasons.length &&
        promises.push(store.dispatch(globalActions.getSeasons()));

    const teamPromise =
        currentTeam?.id === teamId ? Promise.resolve() : getTeam(teamId);

    const [fetchedTeam] = await Promise.all([teamPromise, ...promises]);

    const currentYear = parseInt(
        selectSetting(store.getState(), "majorybl_current_league_year")
            ?.setting,
    );

    let team = currentTeam
        ? currentTeam.id === teamId
            ? currentTeam
            : fetchedTeam?.team
        : fetchedTeam?.team;

    const playerAction = /team\/\d+\/roster\/add\/?$/.test(request.url)
        ? "Add"
        : "Edit";

    const currentAgeLevel = team?.ageLevels.find(t => t.year === currentYear);

    const teamAgeLevel = team?.ageLevels.reduce((prev, current) => {
        return new Date(current.year, current.season.id) >
            new Date(prev.year, prev.season.id)
            ? current
            : prev;
    }, team?.ageLevels[0]);

    const ageLevel = currentAgeLevel || teamAgeLevel;

    const header = `${team?.name} ${ageLevel ? `(${ageLevel.ageLevel})` : ""} / ${playerAction} Player`;

    return {
        teamId,
        team,
        header,
    };
};

export default playerLoader;
